<template>
    <div class="app-container">
        <div class="filter-container">
            <el-button class="filter-item" type="primary" icon="el-icon-edit" @click="handleCreate">添加</el-button>
        </div>
        <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" border fit highlight-current-row>
            <el-table-column type="index" label="序号" align="center" width="100" />
            <el-table-column label="图片" min-width="200" align="center">
                <template slot-scope="scope">
                    <img :src="scope.row.cover_url" style="height:80px" />
                </template>
            </el-table-column>
            <el-table-column label="跳转类型" min-width="200" align="center">
                <template slot-scope="scope">
                    <template v-if="scope.row.link_type === 1">活动</template>
                    <template v-if="scope.row.link_type === 2">测评体验</template>
                    <template v-if="scope.row.link_type === 3">公众号文章</template>
                    <template v-if="scope.row.link_type === 4">平台内文</template>
                    <template v-if="scope.row.link_type === 5">无跳转</template>
                </template>
            </el-table-column>

            <el-table-column align="center" label="点击次数" min-width="110">
                <template slot-scope="scope">
                    <span>{{ scope.row.click_number }}</span>
                </template>
            </el-table-column>

            <el-table-column align="center" label="点击人数" min-width="110">
                <template slot-scope="scope">
                    <span>{{ scope.row.click_number_people }}</span>
                </template>
            </el-table-column>

            <el-table-column align="center" label="状态" min-width="110">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.state" type="success">正常</el-tag>
                    <el-tag v-else type="danger">已下架</el-tag>
                </template>
            </el-table-column>

            <el-table-column label="创建时间" prop="created_at" width="200" align="center"></el-table-column>
            <el-table-column label="操作" align="center" width="158" class-name="small-padding fixed-width" fixed="right">
                <template slot-scope="scope">
                    <el-button size="mini" @click="handleUpdate(scope.row)">编辑</el-button>

                    <el-button size="mini" type="danger" @click="handleDel(scope.row.id)">删除</el-button>

                    <el-button v-if="scope.row.state === 0" type="primary" size="mini" style="margin-top: 5px;"
                        @click="switchState('上架', scope.row.id)">上架</el-button>

                    <el-button v-else type="warning" size="mini" style="margin-top: 5px;"
                        @click="switchState('下架', scope.row.id)">下架</el-button>


                </template>
            </el-table-column>
        </el-table>

        <div class="pagination-container">
            <el-pagination :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
                :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
                @current-change="handleCurrentChange" />
        </div>

        <TableActionModal :show.sync="dialogFormVisible" :type="modalType" :edit-data="editData"
            @onUpdate="onTableActionModalSubmit" />
    </div>
</template>

<script>
import { getQiniuToken } from "@/api/common";
import { banner } from "@/api/operation";
import request from "@/utils/request";
import { guid, base64toFile } from "@/utils/index";
import "babel-polyfill"; // es6 shim
import TableActionModal from "./components/TableActionModal.vue"
import * as qiniu from "qiniu-js";

export default {
    data() {
        return {
            list: null,
            total: null,
            listLoading: true,
            activityList: {
                page: 1,
                limit: 10
            },
            listQuery: {
                page: 1,
                limit: 10
            },
            dialogFormVisible: false,
            modalType: 'add',
            editData: null,
            btnLoading: false,
            activityLoading: true,
            imgBase64Data: "" // the datebase64 url of created image
        };
    },
    components: {
        TableActionModal
    },
    created() {
        this.getList();
        this.activityIndex();
    },
    methods: {
        switchState(text, id) {
            this.$confirm("此操作将" + text + "该banner, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                banner.state({ id })
                    .then(() => {
                        this.$message({
                            message: "操作成功!",
                            type: "success"
                        });
                        this.getList();
                    })
                    .catch(() => {
                        this.$message.error("操作失败!");
                    });
            });
        },
        getList() {
            this.listLoading = true;
            request({
                url: "/api/backend/banners?category_id=3", // category_id:{1.首页轮播图}
                method: "get",
                params: this.listQuery
            }).then(response => {
                this.list = response.data.data;
                this.total = response.data.total;
                this.listLoading = false;
            });
        },
        activityIndex() {
            // if(refresh)this.form.car_type_id=null
            this.activityLoading = true
            request({
                url: '/api/backend/activity/index',
                method: 'GET',
                params: {
                }
            }).then(res => {
                console.log(res.data)
                this.activityList = res.data.data
                this.activityLoading = false
            }).catch(err => {
                console.log(err)
            })
        },
        handleSizeChange(val) {
            this.listQuery.limit = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.listQuery.page = val;
            this.getList();
        },
        onTableActionModalSubmit() {
            this.getList();
        },
        // 更改模式
        setModalType(type) {
            this.modalType = type
        },
        handleCreate() {
            this.setModalType('add')
            this.dialogFormVisible = true;
        },
        handleUpdate(row) {
            this.setModalType('edit')
            this.editData = row
            this.dialogFormVisible = true;
        },
        handleDel(val) {
            this.$confirm("确定要删除, 是否继续?", "提示", {
                type: "warning"
            })
                .then(() => {
                    request({
                        url: "/api/backend/banners/delete",
                        method: "post",
                        params: { id: val }
                    }).then(() => {
                        this.getList();
                        this.$message({
                            type: "success",
                            message: "删除成功!"
                        });
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消"
                    });
                });
        },
        // 废弃函数？
        cropSuccess(imgBase64Data, field) {
            console.log("-------- 裁剪成功 --------");
            let that = this;
            this.imgBase64Data = imgBase64Data;
            getQiniuToken().then(response => {
                let file = base64toFile(imgBase64Data, "tmp.png");
                let key = guid() + ".png";
                let token = response.data.token;
                let baseUrl = response.data.baseUrl;
                let putExtra = {};
                let config = {
                    useCdnDomain: true,
                    region: qiniu.region.z2
                };
                var observable = qiniu.upload(file, key, token, putExtra, config);
                var subscription = observable.subscribe({
                    next(res) {
                        // ...
                    },
                    error(err) {
                        // ...
                    },
                    complete(res) {
                        // ...
                        let imgUrl = baseUrl + "/" + key;
                        that.form.img = imgUrl;
                        console.log(imgUrl);
                    }
                }); // 上传开始
                // or
                // var subscription = observable.subscribe(next, error, complete) // 这样传参形式也可以
                // subscription.unsubscribe() // 上传取消
            });
        }
    }
};
</script>

<style>
.upload-block {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 120px;
    height: 120px;
}

.uploaded-img {
    width: 120px;
    height: 120px;
}

.upload-block:hover {
    border-color: #409eff;
}

.uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
}

.upload-one-component .upload-one-component-image {
    width: auto;
    height: 200px;
}
</style>
